import React from 'react';

interface MarqueeProps {
  items: string[];
  reverse?: boolean;
  className?: string;
  separator?: React.ReactNode;
}

/**
 * Infinite marquee strip. Content is duplicated once and translated -50%
 * for a seamless loop; animation is pure CSS (see index.html keyframes).
 */
const Marquee: React.FC<MarqueeProps> = ({ items, reverse = false, className, separator }) => {
  const sep = separator ?? <span className='text-accent mx-5 sm:mx-7 select-none'>✦</span>;

  const row = (
    <>
      {items.map((item, i) => (
        <span key={i} className='inline-flex items-center whitespace-nowrap'>
          {item}
          {sep}
        </span>
      ))}
    </>
  );

  return (
    <div className={`overflow-hidden ${className ?? ''}`}>
      <div
        className={`flex w-max items-center ${reverse ? 'animate-marquee-reverse' : 'animate-marquee'}`}
      >
        <div className='flex items-center'>{row}</div>
        <div className='flex items-center' aria-hidden='true'>
          {row}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
